import {Component,Input,Output,EventEmitter, OnInit, SimpleChanges} from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: "ngbd-dropdown-basic",
  templateUrl: "./dropdown-basic.html",
  styleUrls: ["./dropdown-basic.scss"],
})
export class NgbdDropdownBasic implements OnInit {
  @Input() id: string;
  @Input() options;
  @Input() config;
  @Input() value = [];
  @Input() placeholder: string;
  @Output() change = new EventEmitter<any[]>();

  subject: Subject<string> = new Subject();

  data: any[] = [];
  list: any[] = [];

  loading: boolean = true;

  ngOnInit() {}

  async ngOnChanges(changes: SimpleChanges) {
    if(this.value.length > 0){
      this.list = this.options.map(item=>{
        return {
          ...item,
          checked: this.value.find(val=>val.id == item.id)? true: false
        }
      });
    }else{
      if(Array.isArray(this.options)){
        this.list = this.options.map(item=>{
          return {
            ...item,
            checked: false
          }
        });
      }
    }

    this.subject.pipe().subscribe((x) => this.filter(x));
  }

  onKeyup(value: string) {
    this.subject.next(value);
  }

  async filter(x: string) {

    this.list = this.options.filter((p) => String(p.label).startsWith(x));
  }

  async reset() {
    this.loading = false;

    setTimeout(() => {
      this.loading = true;
    }, 100);
  }

  check(option) {

    if (this.config.multiple) {
      option.checked = !option.checked;
      this.data = this.list.filter((x: any) => x.checked).map((x) => {
          return { id: x.id, label: x.label };
        });
      this.change.emit(this.data);
    } else {
      this.list.filter((x: any) => x.checked).map((x) => {
          x.checked = !x.checked;
      });
      option.checked = !option.checked;

      this.data = this.list.filter((x: any) => x.checked).map((x) => {
          return { id: x.id, label: x.label };
        });
      this.change.emit(this.data);
    }
  }
}
